/* START_MODULE_CONTRACT
 * PURPOSE: Frontend UI module: PrivateRoute.
 * SCOPE: React component or page.
 * DEPENDS: M-FE-API, M-FE-AUTH
 * LINKS: M-FE-AUTH
 * END_MODULE_CONTRACT
 *
 * START_MODULE_MAP
 * PrivateRoute - Frontend UI module: PrivateRoute.
 * END_MODULE_MAP
 *
 * START_CHANGE_SUMMARY
 * LAST_CHANGE: 2026-07-02 - GRACE coverage: function contract и парный END_METHOD.
 * END_CHANGE_SUMMARY
 */

import { Navigate, Outlet } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { useAuth } from '../context/AuthContext';

/* START_METHOD_PrivateRoute */
/* START_CONTRACT: PrivateRoute
 * PURPOSE: Guard приватных маршрутов: спиннер при загрузке, редирект на /login при отсутствии сессии.
 * INPUTS: нет (использует useAuth).
 * OUTPUTS: { JSX.Element - Outlet | Navigate | спиннер }.
 * SIDE_EFFECTS: нет.
 * LINKS: M-FE-AUTH
 * END_CONTRACT: PrivateRoute
 */
export default function PrivateRoute() {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />;
}
/* END_METHOD_PrivateRoute */
